var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('expo-matching-state', _vm._b({
    on: {
      "input": _vm.pushMatchings
    }
  }, 'expo-matching-state', {
    value: _vm.value,
    program: _vm.program,
    employee: _vm.employee,
    employer: _vm.employer,
    isUserHost: _vm.isUserHost,
    isUserEmployee: _vm.isUserEmployee,
    isUserEmployer: _vm.isUserEmployer
  }, false));
}
var staticRenderFns = []

export { render, staticRenderFns }